// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VidgetSubmitForm_wrapper__kbJCa {
    height: 40px;
    border: 1px solid green;
    display: flex;    
    align-items: center;
    justify-content: center;
    color: green;
    font-weight: 700;    
}

.VidgetSubmitForm_error__ZvWav {
    border: 1px solid red;
    color: red;
}`, "",{"version":3,"sources":["webpack://./src/components/VidgetSubmitForm/VidgetSubmitForm.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd","sourcesContent":[".wrapper {\r\n    height: 40px;\r\n    border: 1px solid green;\r\n    display: flex;    \r\n    align-items: center;\r\n    justify-content: center;\r\n    color: green;\r\n    font-weight: 700;    \r\n}\r\n\r\n.error {\r\n    border: 1px solid red;\r\n    color: red;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `VidgetSubmitForm_wrapper__kbJCa`,
	"error": `VidgetSubmitForm_error__ZvWav`
};
export default ___CSS_LOADER_EXPORT___;
